import React from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { Input, Button, Typography } from "../core";
import { MixStyle } from "../styles";
import { useSelector, useDispatch } from "react-redux";
import { editSizer } from "../redux/Action/Sizer/sizer";
const Notify_Utils = require("../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;
const EditForm = ({ form, SizerId, onCancel, onCreate, ...rest }) => {
  const { token } = useSelector((state) => state.auth);

  console.log(SizerId);
  const dispatch = useDispatch();
  let Error = useSelector((state) => state.errorReducer);

  const {
    address_sizer,
    ntn_sizer,
    phone_no_sizer,
    sizer_name,
    strn_sizer,
    company_id,
  } = useSelector((state) => state.sizer.sizer).filter((data) => {
    return data.sizer_id === SizerId.id;
  })[0];
  const [edit] = React.useState({
    address_sizer,
    ntn_sizer,
    phone_no_sizer,
    sizer_name,
    strn_sizer,
  });
  const [state, setstate] = React.useState({
    company_id,
  });

  const onFinish = (values) => {
    console.log("edit buyer state", state);
    dispatch(editSizer(state, token, SizerId.id));
    if (Error.id === "UPDATE_SIZER_SUCCESS") {
      onCancel();
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  // console.log("buyerData", buyerId);
  const onValuesChange = (changedValues, valuse) => {
    console.log(valuse);
    if (changedValues.sizer_name) {
      setstate((prev) => ({
        ...prev,
        sizer_name: changedValues.sizer_name,
      }));
    } else if (changedValues.address_sizer) {
      setstate((prev) => ({
        ...prev,
        address_sizer: changedValues.address_sizer,
      }));
    } else if (changedValues.phone_no_sizer) {
      setstate((prev) => ({
        ...prev,
        phone_no_sizer: changedValues.phone_no_sizer,
      }));
    } else if (changedValues.ntn_sizer) {
      setstate((prev) => ({
        ...prev,
        ntn_sizer: changedValues.ntn_sizer,
      }));
    } else if (changedValues.strn_sizer) {
      setstate((prev) => ({
        ...prev,
        strn_sizer: changedValues.strn_sizer,
      }));
    } else {
      setstate((prev) => ({
        ...prev,
      }));
    }
  };
  return (
    <div>
      {Error.id === "UPDATE_SIZER_FAIL" ? (
        Object.values(Error.msg).map((items, index) => {
          return Notify_Utils.openNotificationWithIcon(
            "error",
            `${items[0]}`,
            "white"
          );
        })
      ) : Error.id === "UPDATE_SIZER_SUCCESS" ? (
        <>
          {Notify_Utils.openNotificationWithIcon("success", Error.msg)}
          {form.resetFields()}
          {/* {onCreate()} */}
          {/* <Redirect to="/add-contract" /> */}
        </>
      ) : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={edit}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="Sizer Name"
              name="sizer_name"
              rules={[
                {
                  required: true,
                  message: "Please input Sizer Name!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="Sizer Address"
              name="address_sizer"
              rules={[
                {
                  required: true,
                  message: "Please Enter Sizer Address",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="NTN Sizer"
              name="ntn_sizer"
              rules={[
                {
                  required: true,
                  message: "Please input Sizer NTN!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="STRN SIZER"
              name="strn_sizer"
              rules={[
                {
                  required: true,
                  message: "Please input Sizer STRN!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="Sizer Phone Number"
              name="phone_no_sizer"
              rules={[
                {
                  required: true,
                  message: "Please input Sizer Phone Number!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={20}>
            <Form.Item>
              <Row type="flex" gutter={(16, 16)} justify="space-between">
                <Col md={12}>
                  <Button
                    // width="187px"
                    bg="#404E67"
                    type="primary"
                    htmlType="submit"
                  >
                    <Typography
                      text="Update Sizer"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Col>
                <Col md={12}>
                  <Button
                    // width="187px"
                    bg="#404E67"
                    type="primary"
                    onClick={onCancel}
                  >
                    <Typography
                      text="Cancel"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </StyledForm>
    </div>
  );
};
export default EditForm;
